import {
  HttpErrorResponse,
  HttpHandler,
  HttpHeaderResponse,
  HttpInterceptor,
  HttpProgressEvent,
  HttpRequest,
  HttpResponse,
  HttpSentEvent,
  HttpUserEvent,
} from '@angular/common/http';
import { Injectable, Injector } from '@angular/core';
import { Router } from '@angular/router';
import { AuthUtilsService } from '@app/auth/services/auth-utils.service';
import { AuthenticationService } from '@app/auth/services/authentication.service';
import { OIDCService } from '@app/auth/services/oidc.service';
import { ToastService } from '@app/portal/services/toast-service';
import { Logger } from '@app/utils/logger';
import { TranslateService } from '@ngx-translate/core';
import { Observable, Subject, throwError } from 'rxjs';
import { catchError, debounceTime } from 'rxjs/operators';

@Injectable()
export class UnauthorizedInterceptor implements HttpInterceptor {
  private showUnauthorizedToast$ = new Subject<void>();

  constructor(
    private injector: Injector,
    private router: Router,
    toastService: ToastService,
    translateService: TranslateService
  ) {
    this.showUnauthorizedToast$.pipe(debounceTime(100)).subscribe(() => {
      toastService.show({
        body: translateService.instant('session.unauthorized'),
        hideOpenToasts: true,
        type: 'danger',
      });
    });
  }

  intercept(
    req: HttpRequest<any>,
    next: HttpHandler
  ): Observable<
    HttpSentEvent | HttpHeaderResponse | HttpProgressEvent | HttpResponse<any> | HttpUserEvent<any>
  > {
    // Logger.debug('UnauthorizedInterceptor', req, next)
    return next.handle(req).pipe(
      catchError((err) => {
        const authService: AuthenticationService = this.injector.get(AuthenticationService);
        const authUtilsService: AuthUtilsService = this.injector.get(AuthUtilsService);
        const oidcService: OIDCService = this.injector.get(OIDCService);
        if (authService.isAuthenticated) {
          const unauthorized = err instanceof HttpErrorResponse && err.status === 401;

          if (unauthorized) {
            Logger.debug('Http Interceptor: Unauthorized');
            let portalRedirectUrl = err.headers.get('portal_redirect_url');
            if (portalRedirectUrl != null && window.location.href.includes(portalRedirectUrl) === false) {
              Logger.debug('portal_redirect_url', portalRedirectUrl);
              oidcService.logout(window.location.origin + '/login', 500).subscribe((success) => {
                if (success === false) {
                  window.location.replace(portalRedirectUrl);
                }
              });
            } else {
              this.showUnauthorizedToast$.next();
              oidcService.logout(window.location.origin + this.router.url, 500).subscribe((success) => {
                if (success === false) {
                  authUtilsService.redirectToLogin(this.router.url);
                }
              });
            }
          }
        }

        return throwError(err);
      })
    );
  }
}
